import { Component, AfterViewInit, Input } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { CaseService } from '../../shared/services/case.service';
import { UserService } from '../../shared/services/user.service';
import { TaskService } from '../../shared/services/task.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-reallocate-case',
  templateUrl: './reallocate-case.component.html',
  styleUrls: ['./reallocate-case.component.scss']
})
export class ReallocateCaseModalComponent implements AfterViewInit {

  @Input() selection: any[] = [];

  paralegalUsers: any[] = [];
  adminUsers: any[] = [];

  selectedParalegal: any = null;
  selectedAdmin: any = null;

  invalidSelection: boolean = true;
  isLoading: boolean = false;

  constructor(
    public activeModal: NgbActiveModal,
    private caseService: CaseService,
    userService: UserService,
    private taskService: TaskService) {

    userService.paralegals().subscribe(results => {
      this.paralegalUsers = results.map(user => ({ name: user.firstName + ' ' + user.lastName, id: user.id }));
    });

    userService.admins().subscribe(results => {
      this.adminUsers = results.map(user => ({ name: user.firstName + ' ' + user.lastName, id: user.id }));
    });
  }

  selectionUpdated() {
  this.invalidSelection = !(
    (this.selectedParalegal != null) ||
    (this.selectedAdmin != null)
  );
 }

  reallocateCases() {
    this.isLoading = true;

    const paralegalId = this.selectedParalegal?.id ?? -1;
    const adminId = this.selectedAdmin?.id ?? -1;

    this.caseService.reallocateCases(
      paralegalId,
      adminId,
      this.selection.map((x: any) => x.id)
    ).subscribe({
      next: (response: any) => {
        this.activeModal.close(true);
        this.taskService.refreshTasks.next();
      },
      error: (error: any) => {
        this.isLoading = false;
      }
    });
  }

  cancel() {
    this.activeModal.dismiss();
  }

  ngAfterViewInit(): void {}
}